var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{ref:"video",attrs:{"muted":"","autoplay":"","src":_vm.getUrl(_vm.media)},domProps:{"muted":true},on:{"ended":_vm.ended,"error":_vm.error,"canplay":_vm.successLoad}})}
var staticRenderFns = []

export { render, staticRenderFns }